@if (showField) {
    <div class="agpr-formField agpr-numberField">
        <agpr-number-input
            pInputText
            type="number"
            class="agpr-numberField-input"
            [id]="id + '.numberFieldInput'"
            [placeholder]="field.placeholder | localize"
            [tooltip]="field.toolTip | localize"
            [(ngModel)]="value"
            [min]="field.min"
            [max]="field.max"
            (ngModelChange)="inputChange($event)"
            [label]="field.label | localize"
        ></agpr-number-input>
        <div
            *ngIf="field.description"
            class="agpr-formField-description"
        >
            {{ field.description | localize }}
        </div>
    </div>
}
